
import React from 'react';

export interface TicketType {
  id: number;
  name: string;
  price: string;
  description: string;
  features: React.ReactNode[];
  popular: boolean;
  borderStyle: string;
  buttonText: string;
  shopifyLink: string;
}

// Updated ticket types with new prices
export const ticketTypes: TicketType[] = [
  {
    id: 1,
    name: "Early Bird",
    price: "£495",
    description: "Limited availability - Full 2-Days Pass",
    features: [
      React.createElement("span", { key: "full-pass", className: "font-bold text-black" }, "Full 2-Days Pass (In-Person)"),
      "Access to all keynotes",
      "Book by 5th November",
      "Access to all sessions",
      "Conference materials",
      "Lunch and refreshments",
      "Access to Networking Portal and Delegates List"
    ],
    popular: false,
    borderStyle: "border-purple-500",
    buttonText: "Book Now!",
    shopifyLink: "https://booking.aiconference.london/products/ai-world-congress-2026-nov"
  },
  {
    id: 2,
    name: "VIP Pass", 
    price: "£695",
    description: "Regular VIP early price for all 2-days conference days",
    features: [
      React.createElement("span", { key: "full-pass", className: "font-bold text-black" }, "Full 2-Days Pass (In-Person)"),
      "Access to all keynotes",
      "Book by 5th November",
      "Access to all sessions",
      "Conference materials",
      "Lunch and refreshments",
      "Access to Networking Portal and Delegates List",
      "+Access to All Recorded Videos"
    ],
    popular: false,
    borderStyle: "border-purple-500",
    buttonText: "Book Now!",
    shopifyLink: "https://booking.aiconference.london/products/ai-world-congress-2026-nov?variant=53889774780759"
  },
  {
    id: 3,
    name: "Full Price", 
    price: "£2,295",
    description: "Full Price ticket without early bird discounts",
    features: [
      React.createElement("span", { key: "full-pass", className: "font-bold text-black" }, "Full 2-Days Pass (In-Person)"),
      "Access to all keynotes",
      "Book by 25th November",
      "Access to all sessions",
      "Conference materials",
      "Lunch and refreshments",
      "Access to Networking Portal and Delegates List",
      "+Access to All Recorded Videos"
    ],
    popular: false,
    borderStyle: "border-purple-500",
    buttonText: "Book Now!",
    shopifyLink: "https://booking.aiconference.london/products/ai-world-congress-2026-nov?variant=53889774813527"
  }
];
